import type { IModelPOSTAiChatSendRequest, IModelPOSTAiChatRatingRequest } from './dto/ai-chat.dto';

export class AiChatRepository {
  private api: any;
  private configService: any;
  private tgSocialBase: string;
  private tgSocialService: string;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.tgSocialBase = runtimeConfig.public.apiTGSocialBase;
    this.tgSocialService = runtimeConfig.public.apiTGSocialService;
  }

  async sendMessage(params: IModelPOSTAiChatSendRequest): Promise<Response> {
    const response = await this.api(
      `${this.tgSocialService}v1/ai-chat-sse/send`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: JSON.stringify({
          sessionId: params.sessionId,
          message: params.message,
        }),
      }
    );
    return response;
  }

  async submitRating(params: IModelPOSTAiChatRatingRequest): Promise<Response> {
    const response = await this.api(
      `${this.tgSocialService}v1/ai-chat-sse/rating`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: JSON.stringify({
          sessionId: params.sessionId,
          rating: params.rating,
          feedback: params.feedback ?? '',
        }),
      }
    );
    return response;
  }

  async subscribeStream(sessionId: string, signal?: AbortSignal): Promise<Response> {
    const response = await useApiFetchSSE(
      `${this.tgSocialService}/v1/ai-chat-sse/stream?sessionId=${encodeURIComponent(sessionId)}`,
      {
        baseUrl: this.tgSocialBase,
        method: 'GET',
        signal,
      }
    );
    return response;
  }
}
